import { render, staticRenderFns } from "./VfAutocomplete.vue?vue&type=template&id=4e2cdc80&scoped=true&"
import script from "./VfAutocomplete.vue?vue&type=script&lang=js&"
export * from "./VfAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2cdc80",
  null
  
)

export default component.exports